export default __webpack_public_path__ + "static/media/btn_step_1_hover.0bdf8727.svg";